import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

/**
 * Display a dialog to download a document of results
 */
@Component({
  selector: 'app-dialog-results',
  templateUrl: './dialog-results.component.html'
})
export class DialogResultsComponent {
  /** Dialog reference */
  dialogRef: MatDialogRef<DialogResultsComponent>;
  /** Injected data */
  data: any;

  /** init component, inject dialog reference and data */
  constructor(
    dialogRef: MatDialogRef<DialogResultsComponent>,
    @Inject(MAT_DIALOG_DATA) data: any) {
      this.dialogRef = dialogRef;
      this.data = data;
    }

  /** Close dialog */
  onNoClick(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/dialogs/dialog-results/dialog-results.component.ts